import {
  createPlugin,
  configApiRef,
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';
import {} from '.';
import { TruewatchDashboardApiRef, TruewatchDashboardClient } from './apis';
export const truewatchDashboardPlugin = createPlugin({
  id: 'truewatch-dashboard',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: TruewatchDashboardApiRef,
      deps: {
        configApi: configApiRef,
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory({ configApi, discoveryApi, fetchApi }) {
        return new TruewatchDashboardClient({
          discoveryApi,
          fetchApi,
          baseUrl: configApi.getOptionalString('truewatchdashboard.baseUrl'),
        });
      },
    }),
  ],
});

export const TruewatchDashboardPage = truewatchDashboardPlugin.provide(
  createRoutableExtension({
    name: 'TruewatchDashboardPage',
    component: () =>
      import('./components/TruewatchDashboardComponent').then(m => m.TruewatchDashboardComponent),
    mountPoint: rootRouteRef,
  }),
);
